// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stores[data-v-288ef63c]{display:grid;grid-gap:20px;grid-template-columns:2fr 3fr;margin-bottom:30px;@media (max-width:1400px){grid-template-columns:3fr 5fr}@media (max-width:1200px){grid-template-columns:2fr 3fr}@media (max-width:998px){grid-template-columns:none}}.stores__map[data-v-288ef63c]{@media (max-width:998px){min-height:400px;order:0}}.stores__list[data-v-288ef63c]{@media (max-width:998px){order:1}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
